export const months = {
  "jan-19": ["2019-01-01", "2019-01-31"],
  "feb-19": ["2019-02-01", "2019-02-28"],
  "mar-19": ["2019-03-01", "2019-03-31"],
  "apr-19": ["2019-04-01", "2019-04-30"],
  "may-19": ["2019-05-01", "2019-05-31"],
  "jun-19": ["2019-06-01", "2019-06-30"],
  "jul-19": ["2019-07-01", "2019-07-31"],
  "aug-19": ["2019-08-01", "2019-08-31"],
  "sep-19": ["2019-09-01", "2019-09-30"],
  "oct-19": ["2019-10-01", "2019-10-31"],
  "nov-19": ["2019-11-01", "2019-11-30"],
  "dec-19": ["2019-12-01", "2019-12-31"],
  "jan-20": ["2020-01-01", "2020-01-31"],
  "feb-20": ["2020-02-01", "2020-02-29"],
  "mar-20": ["2020-03-01", "2020-03-31"],
  "apr-20": ["2020-04-01", "2020-04-30"],
  "may-20": ["2020-05-01", "2020-05-31"],
  "jun-20": ["2020-06-01", "2020-06-30"],
  "jul-20": ["2020-07-01", "2020-07-31"],
  "aug-20": ["2020-08-01", "2020-08-31"],
  "sep-20": ["2020-09-01", "2020-09-30"],
  "oct-20": ["2020-10-01", "2020-10-31"],
  "nov-20": ["2020-11-01", "2020-11-30"],
  "dec-20": ["2020-12-01", "2020-12-31"],
  "jan-21": ["2021-01-01", "2021-01-31"],
  "feb-21": ["2021-02-01", "2021-02-28"],
  "mar-21": ["2021-03-01", "2021-03-31"],
  "apr-21": ["2021-04-01", "2021-04-30"],
};

export const defaultHosts = {
  PRO: null,
  COM: null,
  MUN: null,
  DIS: null,
  SEC: null,
  population: 0,
  amount: 0,
};

export const defaultOptions = {
  PRO: [],
  COM: [],
  MUN: [],
  DIS: [],
  SEC: [],
};
